import React, { useState, useRef, useEffect } from 'react';
import moment from 'moment';
import { ko } from 'date-fns/locale';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Div, RowDiv, Span, Text } from 'styles';
import { Icon } from 'components/common/Icon';
import { Button } from 'components/button/Button';
import * as S from './CustomDateStyle';

export function CustomDate({ name, label, filters, onChange, hide, onClick, desc }) {
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(moment(filters[name], 'YYYY.MM.DD').toDate());
  const [showYearPicker, setShowYearPicker] = useState(false);
  const ref = useRef(null);

  const handleDateChange = (date) => {
    const tempDate = moment(date).startOf('day').toDate();
    setSelectedDate(tempDate);
    onChange(name, moment(tempDate).format('YYYY.MM.DD'));

    if (showYearPicker) {
      setShowYearPicker(false);
    } else {
      setOpen(false);
    }
  };

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <Div $position="relative" ref={ref}>
      {label && (
        <Text $type="b" $color="assistive" $marginBottom={4}>
          {label}
        </Text>
      )}
      <RowDiv $gap={8}>
        <S.DateDiv $desc={desc} onClick={() => setOpen(!open)}>
          <Icon name="Calendar" $pathFill="primary" />
          <Div $width={104}>
            {desc && (
              <Span $type="m11" $color="supportive">
                {desc}
              </Span>
            )}
            <Text $type="m" $color="assistive">
              {moment(selectedDate).format('YYYY.MM.DD')}
            </Text>
          </Div>
        </S.DateDiv>
        {!hide && (
          <Button $type="standard" $size="small" onClick={() => {
            onChange(name, moment(selectedDate).format('YYYY.MM.DD'));

            if (onClick) {
              onClick();
            }
          }}>
            검색
          </Button>
        )}
      </RowDiv>
      {open && (
        <S.CustomDiv>
          <DatePicker
            locale={ko}
            selected={selectedDate}
            onChange={handleDateChange}
            dateFormat="yyyy.MM.dd"
            placeholderText="날짜를 선택하세요"
            inline
            showYearPicker={showYearPicker}
            renderCustomHeader={({
              date,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
            }) => (
              <Div>
                <Text $textAlign="start" $type="m12" $lineHeight="14px" $color="supportive">
                  {showYearPicker ? '연도 선택' : '일자 선택'}
                </Text>
                <RowDiv $alignItems="center" $justifyContent="space-between" $margin="12px 0">
                  <S.YearDiv onClick={() => setShowYearPicker(!showYearPicker)}>
                    <Text
                      $type="l14"
                      $color="assistive"
                    >{`${moment(date).year()}년 ${`${moment(date).month() + 1}월`}`}</Text>
                    <button type="button" className="btn year" aria-label="연도 선택">
                      <Icon name="DateArrow" />
                    </button>
                  </S.YearDiv>
                  <RowDiv $alignItems="center" $gap={12}>
                    <button
                      type="button"
                      className="btn prev"
                      onClick={decreaseMonth}
                      disabled={prevMonthButtonDisabled}
                      aria-label="이전 달"
                    >
                      <Icon name="DateArrow" />
                    </button>
                    <button
                      type="button"
                      className="btn next"
                      onClick={increaseMonth}
                      disabled={nextMonthButtonDisabled}
                      aria-label="다음 달"
                    >
                      <Icon name="DateArrow" />
                    </button>
                  </RowDiv>
                </RowDiv>
              </Div>
            )}
          />
        </S.CustomDiv>
      )}
    </Div>
  );
}
